export default __webpack_public_path__ + "static/media/Team.fe4fd14c.png";